module.exports = __webpack_public_path__ + "img/chevy-service.89b8ed5a.png";